<template>
  <div class="custom-view-wrapper">
    <div class="dg-content-body">
      <div class="dg-content">
        <div class="form-group primaryCenterSelection">
          <label for="primaryCenter">
            {{ lang.get("users.primaryCenterLabel") }}
          </label>
          <i class="far fa-asterisk" />
          <der-select
            id="move-user-centre-select"
            v-model="primaryCenterId"
            :data-options="props.dataCenters"
            :data-get-option-value="(option) => option.id"
            :data-get-option-label="(option) => option.text"
            :clearable="false"
          />
        </div>
        <div v-if="keepExternalAccessQuestion" class="row">
          <div class="col-1">
            <Checkbox
              form-value="keepExternalAccess"
              :disabled="false"
              :required="false"
              :title="
                lang.get(
                  'admin.usersKeepExternalResourceOnPrimaryCenterChangeLabel',
                )
              "
              @change="toggleKeepAccess"
            />
          </div>
          <div class="col">
            <label for="keepExternalAccess">
              {{
                lang.get("admin.usersKeepExternalResourceOnPrimaryCenterChange")
              }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="dg-content-footer tw-flex tw-justify-between">
      <button class="dg-btn dg-btn--cancel" @click="$emit('close')">
        <span>{{ lang.get("general.modalCancelButton") }}</span>
      </button>
      <button
        class="dg-btn dg-btn--ok"
        data-test="move-user-submit"
        :disabled="submitDisabled"
        @click="handleSubmit"
      >
        <span>{{ lang.get("general.formSaveLabel") }}</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, toRefs } from "vue";
import { lang } from "../../i18n";
import DerSelect from "../Utils/DerSelect.vue";
import Checkbox from "../Examinations/Examination/ExaminationComponents/components/Checkbox.vue";

const emit = defineEmits(["submit", "close"]);

const props = defineProps<{
  dataCenters: Array<{
    id: number;
    text: string;
  }>;
  dataPrimaryCenterId: number;
  submitDisabled: boolean;
  userRoles: object;
}>();

const primaryCenterId = ref(props.dataPrimaryCenterId);
let keepExternalAccess = ref(false);
const keepExternalAccessQuestion = computed(() => {
  return (
    props.userRoles.external_resource ||
    props.userRoles.region_external_resource
  );
});

function handleSubmit() {
  emit("submit", {
    centerId: primaryCenterId.value,
    keepExternalAccess: keepExternalAccess.value,
  });
}

function toggleKeepAccess(event: Event) {
  keepExternalAccess.value = (event.target as HTMLInputElement).checked;
}
</script>
